import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import AuthService from '../services/AuthService';
import { useLoading } from '../context/LoadingContext';
import { useForm } from 'react-hook-form';
import { showSuccessToast, showErrorToast } from '../utils/AlertUtils';
import ResetPasswordForm from '../components/ResetPasswordForm';

function ForgotPassword() {
  const { setIsLoading } = useLoading();
  const navigate = useNavigate();
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(null); // Store OTP
  const [email, setEmail] = useState(null); // Store Email
  const [otpExpired, setOtpExpired] = useState(false); // New state for OTP expiry
  const [resendTimer, setResendTimer] = useState(600);

  const { register: forgotRegister, handleSubmit: forgotHandleSubmit, formState: { errors: forgotErrors } } = useForm();
  const { register: resetRegister, handleSubmit: resetHandleSubmit, formState: { errors: resetErrors } } = useForm();

  const handleForgotPasswordSubmit = async (data) => {
    try {
      setIsLoading(true);
      const { business_email } = data;
      setEmail(business_email); // Store the email
      const response = await AuthService.forgotPassword(business_email);
      if (response && response.statusCode === 200) {
        showSuccessToast(response.message);
        setEmail(business_email);
        setOtp(response.otp);
        setOtpSent(true); // OTP sent successfully, show reset form
        setOtpExpired(false); // Reset expiry on successful OTP send
        startResendTimer();
      }
    } catch (err) {
      showErrorToast(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPasswordSubmit = async (data) => {
    try {
      setIsLoading(true);
      const { otp, password, confirmPassword } = data;

      if(password !== confirmPassword){
        throw new Error("Passwords do not match")
      }
      const response = await AuthService.resetPassword({email, otp, new_password :password});
      if (response && response.statusCode === 200) {
        showSuccessToast(response.message);
        navigate('/auth/login');
      }
    } catch (err) {
      showErrorToast(err.message);
      if (err.message.includes("OTP expired")) { // Check for OTP expiry message
        setOtpExpired(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtpSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await AuthService.forgotPassword(email); // Resend OTP using the stored email
      if (response && response.statusCode === 200) {
        showSuccessToast(response.message);
        setOtpExpired(false);
        setResendTimer(600); // Reset the timer
        startResendTimer();
      }
    } catch (err) {
      showErrorToast(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const startResendTimer = () => {
    const timer = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 0) {
          clearInterval(timer);
          setOtpExpired(true);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000); // Update every second
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div>
      {!otpSent ? (
        <ForgotPasswordForm onSubmit={forgotHandleSubmit(handleForgotPasswordSubmit)} register={forgotRegister} errors={forgotErrors} />
      ) : (
        <ResetPasswordForm onSubmit={resetHandleSubmit(handleResetPasswordSubmit)} register={resetRegister} errors={resetErrors} email={email} otp={otp} formatTime={formatTime} otpExpired={otpExpired} resendTimer={resendTimer} handleResendOtp={handleResendOtpSubmit}/>
      )}
    </div>
  );
}

export default ForgotPassword;